import React, { Component, useState, Radio } from "react";

import axios from '@app/lib/axios';
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { InputGroup, FormControl } from "react-bootstrap";

import AgGridReactEx from "@app/components/AgGridReactEx";

import "../../../../App.css";

import CustomLoadingOverlay from "./CustomLoadingOverlay";
import { param } from "jquery";

const TYPE_MESSAGE = {
    AP: { desc: "승인", bootstrapClass: "success", regexpression: "^(?=.*(\\[시스템.*))(?:.*승인되었습니다|.*승인\\s완료).*$" },
    NA: { desc: "해지", bootstrapClass: "danger", regexpression: "^(?=.*(\\[시스템\\-))(?:.*해지\\s하였습니다|.*해지\\s되었습니다).*$" },
    DN: { desc: "거부", bootstrapClass: "secondary", regexpression: "^(?=.*(\\[시스템.*))(?:.*승인\\s거부).*$" },
    CN: { desc: "취소", bootstrapClass: "secondary", regexpression: "^(?=.*(\\[시스템.*))(?:.*승인\\s요청\\s취소).*$" },
    CH: { desc: "반 변경", bootstrapClass: "warning", regexpression: "^(?=.*(\\[시스템))(?=.*(변경되었습니다)).*$" },
    TR: { desc: "이관", bootstrapClass: "primary", bootstrapClassBadge: "badge-outline badge-primary", regexpression: "^(?=.*(\\[시스템-계약이관)).*$" },
    RE: { desc: "재계약", bootstrapClass: "success", bootstrapClassBadge: "badge-outline badge-success", regexpression: "^(?=.*(\\[시스템))(?=.*(재계약 하였습니다)).*$" },
    NT: { desc: "알림", bootstrapClass: "info", regexpression: "^(?=.*(\\[시스템\\])).*$" },
    BM: { desc: "메시지", bootstrapClass: "primary", regexpression: null },
    "-": { desc: "-", bootstrapClass: "dark", regexpression: null },
};
const copyToClipBoard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};

class SystemMessageTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: null,
            optBranches: null,
            selectedBranchId: -1,
            filter: "ALL",
            tableData: [],
            keyword: null,
            summaryMessage: { AP: 0, RE: 0, TR: 0, DN: 0, NA: 0, CH: 0, NT: 0, BM: 0 },
            isGridReady: false,
            isShowLoading: false,
            frameworkComponents: {
                customLoadingOverlay: CustomLoadingOverlay,
            },
            loadingOverlayComponent: "customLoadingOverlay",
            loadingOverlayComponentParams: { loadingMessage: "Loading..." },
        };
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.branches != null && this.state.optBranches == null) {
            this.setState(
                {
                    branches: nextProps.branches,
                },
                () => {
                    if(this.props.branchId > 0) {
                        this.setState({selectedBranchId: this.props.branchId});
                    };
                    this.setState({ optBranches: this.getOptionBranches() }, () => {
                    });
                }
            );
        }
        if (this.state.optBranches != null) {
            //if (this.state.messages != nextProps.messages) {
                this.gridApi.showLoadingOverlay();
                
                this.parseMessage(nextProps.messages);
                this.renderData(nextProps.messages);
            //}
        }
        if (this.state.isGridReady) {
            if (nextProps.showLoading && !this.state.isShowLoading) {
                this.state.isShowLoading = true;
                this.gridApi.showLoadingOverlay();
            } else if (this.state.isShowLoading) {
                this.gridApi.hideOverlay();
            }
        }
    };

    getOptionBranches = () => {
        if (this.state.branches == null) {
            return null;
        }

        var optBranches = [];
        optBranches.push(
            <option key="branch-all" value="-1">
                전체
            </option>
        );
        for (var i = 0; i < this.state.branches.length; i++) {
            optBranches.push(
                <option key={"branch-" + this.state.branches[i].id} value={this.state.branches[i].id}>
                    {this.state.branches[i].name}
                </option>
            );
        }

        return optBranches;
    };

    parseMessage = (messages) => {
        var list = messages;
        if (list != null && list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].system_yn == "N") {
                    key = "BM";
                    list[i].type_message = key;
                    list[i].type_message_desc =
                        list[i].type == "A" ? `<span>&nbsp;&nbsp;본사<i class="fa fa-chevron-right"></i></span>` : `<span><i class="fa fa-chevron-left"></i>지사&nbsp;&nbsp;</span>`;
                } else {
                    for (var key in TYPE_MESSAGE) {
                        if (key == "BM") {
                            break;
                        }
                        if (list[i].message) {
                            if (list[i].user_ids === undefined) list[i].user_ids = list[i].message.match(/[A-Za-z]+[\d]\w*/g);
                            if (list[i].message.match(TYPE_MESSAGE[key].regexpression)) {
                                list[i].type_message = key;
                                list[i].type_message_desc = TYPE_MESSAGE[key].desc;
                                this.state.summaryMessage[key]++;
                                break;
                            }
                        } else {
                            key = "-";
                            list[i].type_message = key;
                            list[i].type_message_desc = TYPE_MESSAGE[key].desc;
                            break;
                        }
                    }
                }
                var branch = this.state.branches.find((b) => b.id == list[i].branch_id);
                list[i].branch_name = branch ? branch.name : list[i].branch_id;
            }
        }
    };

    renderData = (messages) => {
        var tableData = [];
        var summaryMessage = { AP: 0, RE: 0, TR: 0, NA: 0, DN: 0, CH: 0, NT: 0, BM: 0 };
        var list = messages;
        if (list != null && list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                if (this.state.selectedBranchId == -1 || this.state.selectedBranchId == list[i].branch_id) {
                    summaryMessage[list[i].type_message]++;
                    if (this.state.filter === "ALL" || this.state.filter === list[i].type_message) {
                        if (this.state.keyword === null || !this.state.keyword) this.addToTableData(tableData, list[i], summaryMessage);
                        else if (list[i].message.indexOf(this.state.keyword) > -1) this.addToTableData(tableData, list[i], summaryMessage);
                    }
                }
            }
        }
        this.setState({ tableData: tableData, summaryMessage: summaryMessage }, () => {
            this.state.isShowLoading = false;
            this.gridApi.hideOverlay();
            this.setState({
                tableSummary: this.state.tableData.length.toLocaleString() + "/" + (this.props.messages ? this.props.messages.length : 0).toLocaleString(),
            });
        });
    };

    addToTableData = (tableData, row) => {
        tableData.push(row);
    };

    onFilterChanged = (e) => {
        var filter = e.currentTarget.querySelector("input").value;
        if (filter !== this.state.filter) {
            this.gridApi.showLoadingOverlay();
            this.setState({ filter: filter }, () => {
                this.renderData(this.props.messages);
            });
        }
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.state.isGridReady = true;
        this.props.onGridReadyHandler();
    };

    onFirstDataRendered = (params) => {
        //params.api.hideOverlay()
        // var allColumnIds = [];
        // this.gridColumnApi.getAllColumns().forEach(function(column) {
        //     allColumnIds.push(column.colId);
        // });
        // this.gridColumnApi.autoSizeColumns(allColumnIds, true);
    };

    onRowDataChanged = (params) => {
        this.setState({
            tableSummary: this.state.tableData.length.toLocaleString() + "/" + (this.props.messages ? this.props.messages.length : 0).toLocaleString(),
        });

        var allColumnIds = ["message"];
        params.columnApi.autoSizeColumns(allColumnIds, true);
    };

    onBranchChange = (e) => {
        this.gridApi.showLoadingOverlay();
        this.setState({ selectedBranchId: e.target.value }, () => {
            this.renderData(this.props.messages);
        });
    };

    onSearchList = (e) => {
        var keyword = e.target.value;
        this.state.keyword = keyword;
    };
    
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.renderData(this.props.messages);
        }
    };

    onMessageSelect = (params) => {
        var selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows != null && selectedRows.length > 0) {
            //console.debug(selectedRows[0])
        }
    };

    onClickCopyAccount = (e, param) => {
        e.currentTarget.blur();
        if (param.value != null && param.value.length > 0) {
            var text = "";
            for (var i = 0; i < param.value.length; i++) {
                text += param.value[i] + "\r\n";
            }
            copyToClipBoard(text);
            this.props.toast("계정 목록을 클립보드에 복사하였습니다.", { type: this.props.toast.TYPE.INFO });
        }
    };

    onBtnExportDataAsCsv = () => {
        var fileName = "system_message_" + this.props.startDate.replace(/-/gi, "") + "-" + this.props.endDate.replace(/-/gi, "") + ".csv";
        this.gridApi.exportDataAsCsv({ fileName: fileName });
    };

    listColumn = [
        {
            headerName: "ID",
            field: "id",
            maxWidth: 100,
            minWidth: 80,
            resizable: true,
            sort: "desc",
            pinned: "left",
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "작성일",
            field: "create_date",
            sortable: true,
            maxWidth: 170,
            minWidth: 170,
            pinned: "left",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "지사",
            field: "branch_name",
            sortable: true,
            maxWidth: 200,
            minWidth: 120,
            pinned: "left",
            cellClass: "text-left",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "메시지내 계정",
            field: "user_ids",
            sortable: true,
            maxWidth: 250,
            minWidth: 150,
            pinned: "left",
            cellClass: "text-left",
            cellRendererFramework: (param) => {
                if (param.value) {
                    var ids = param.value;
                    var idList = "";
                    if (ids && ids.length > 0) {
                        for (var i = 0; i < ids.length; i++) {
                            idList += ids[i];
                            if (i < ids.length - 1) idList += ", ";
                        }
                    }
                    return (
                        <div className="row w-100">
                            <div className="col-8" style={{ overflow: "scroll" }}>
                                {idList ? (
                                    <>
                                        <span className="badge badge-info badge-message-id-count" title="메시지에 포함된 계정 수">
                                            {ids.length}
                                        </span>
                                        {idList}
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="col-4 text-right">
                                <button
                                    className="btn btn-outline-dark"
                                    style={{ marginTop: "-6px", border: "0px" }}
                                    data-toggle="tooltip"
                                    title="클립 보드로 복사"
                                    data-delay='{"show":"500", "hide":"1000"}'
                                    onClick={(e) => this.onClickCopyAccount(e, param)}
                                >
                                    <i className="fas fa-clone" style={{ color: "#999999" }}></i>
                                </button>
                                {/* <ReactTooltip id={"tipClipboard_" + param.data.id} place="right" type="dark" effect="float" style={{zIndex:"999999"}}>
                                        <span>클립보드로 복사</span>
                                    </ReactTooltip> */}
                            </div>
                        </div>
                    );
                } else return <span>-</span>;
            },
        },
        {
            headerName: "유형",
            field: "type_message_desc",
            sortable: false,
            maxWidth: 90,
            minWidth: 90,
            cellClass: "text-center",
            cellRenderer: (param) => {
                if(param.data && param.data.type_message) {
                    var type_message = TYPE_MESSAGE[param.data.type_message];
                    return `<span class="badge ${type_message.bootstrapClassBadge ? type_message.bootstrapClassBadge : `badge-${type_message.bootstrapClass}`}" style="display: inline-block; width:65px">
                                ${param.value}
                            </span>`;
                }
                return '-';
            },
            // cellRendererFramework: (param) => {
            //     var type_message = TYPE_MESSAGE[param.data.type_message]
            //     return <span className={"badge badge-" + type_message.bootstrapClass} style={{display:"inline-block", width:"65px"}}>
            //                 {param.value}
            //             </span>
            // }
        },
        {
            headerName: "메시지",
            field: "message",
            sortable: true,
            cellClass: "text-left",
            minWidth: 900,
            //width: "100%",
            cellRendererFramework: (param) => {
                return param.data.message ? (
                    param.data.message
                ) : param.data.filePath ? (
                    <a href='" + param.data.filePath + "' target="_blank" class="btn btn-success">
                        이미지 보기
                    </a>
                ) : (
                    <span>-</span>
                );
            },
        },
    ];

    render() {
        return (
            <div className="card border-top border-3 border-top-info">
                <div className="card-body" style={{}}>
                    <div className="row">
                        {this.props.branchId == 0 && (
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                <InputGroup className="">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>지 사</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <select className="form-control input-group-append" onChange={(e) => this.onBranchChange(e)} style={{ height: "auto" }}>
                                        {this.state.optBranches}
                                    </select>
                                </InputGroup>
                            </div>
                        )}
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-3">
                            <form>
                                <div className="btn-group" data-toggle="buttons">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{ width: "80px", justifyContent: "center" }}>필 터</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <div className="btn-filter btn btn-outline-primary active" onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="ALL" checked={this.state.filter === "ALL"} />
                                        전체
                                    </div>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["AP"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="AP" checked={this.state.filter === "AP"} />
                                        {TYPE_MESSAGE["AP"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["AP"].bootstrapClass}>
                                        {this.state.summaryMessage["AP"] > 99 ? "99+" : this.state.summaryMessage["AP"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["RE"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="RE" checked={this.state.filter === "RE"} />
                                        {TYPE_MESSAGE["RE"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["RE"].bootstrapClass}>
                                        {this.state.summaryMessage["RE"] > 99 ? "99+" : this.state.summaryMessage["RE"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["TR"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="TR" checked={this.state.filter === "TR"} />
                                        {TYPE_MESSAGE["TR"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["TR"].bootstrapClass}>
                                        {this.state.summaryMessage["TR"] > 99 ? "99+" : this.state.summaryMessage["TR"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["NA"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="NA" checked={this.state.filter === "NA"} />
                                        {TYPE_MESSAGE["NA"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["NA"].bootstrapClass}>
                                        {this.state.summaryMessage["NA"] > 99 ? "99+" : this.state.summaryMessage["NA"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["DN"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="DN" checked={this.state.filter === "DN"} />
                                        {TYPE_MESSAGE["DN"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["DN"].bootstrapClass}>
                                        {this.state.summaryMessage["DN"] > 99 ? "99+" : this.state.summaryMessage["DN"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["CH"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="CH" checked={this.state.filter === "CH"} />
                                        {TYPE_MESSAGE["CH"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["CH"].bootstrapClass}>
                                        {this.state.summaryMessage["CH"] > 99 ? "99+" : this.state.summaryMessage["CH"]}
                                    </span>

                                    <div className={"btn-filter btn btn-outline-" + TYPE_MESSAGE["NT"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="NT" checked={this.state.filter === "NT"} />
                                        {TYPE_MESSAGE["NT"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["NT"].bootstrapClass}>
                                        {this.state.summaryMessage["NT"] > 99 ? "99+" : this.state.summaryMessage["NT"]}
                                    </span>

                                    <div className={"btn btn-outline-" + TYPE_MESSAGE["BM"].bootstrapClass} onClick={this.onFilterChanged}>
                                        <input type="radio" name="list-filter" onChange={this.onFilterChanged} value="BM" checked={this.state.filter === "BM"} />
                                        {TYPE_MESSAGE["BM"].desc}
                                    </div>
                                    <span className={"badge-system-message-summary badge badge-" + TYPE_MESSAGE["BM"].bootstrapClass}>
                                        {this.state.summaryMessage["BM"] > 99 ? "99+" : this.state.summaryMessage["BM"]}
                                    </span>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-3 float-right table-total-summary">{this.state.tableSummary}</div>
                        <div className="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-9 mb-1">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5"></div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                                    <Button className="btn btn-secondary" onClick={() => this.onBtnExportDataAsCsv()}>
                                        CSV로 저장
                                    </Button>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-5">
                                    <input className="form-control" type="text" onChange={(e) => this.onSearchList(e)} onKeyPress={this.handleKeyPress} placeholder="메시지 검색" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                height={this.props.height}
                                columnDefs={this.listColumn}
                                defaultColDef={{ resizable: true }}
                                rowData={this.state.tableData}
                                rowSelection="single"
                                enableCellChangeFlash={true}
                                enableCellTextSelection={true}
                                onGridReady={this.onGridReady}
                                //onSelectionChanged={this.onMessageSelect.bind(this)}
                                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                onRowDataChanged={this.onRowDataChanged}
                                frameworkComponents={this.state.frameworkComponents}
                                loadingOverlayComponent={this.state.loadingOverlayComponent}
                                loadingOverlayComponentParams={this.state.loadingOverlayComponentParams}
                                overlayNoRowsTemplate={`<span>메시지 목록이 없습니다.</span>`}
                            ></AgGridReactEx>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SystemMessageTable;
